import React from 'react'

import type { TableHeaders } from '@fourthwall/components'

import { GiftCardStatusTag } from '../../../../components/GiftCardStatusTag/GiftCardStatusTag'
import { type GiftCard } from '../../GiftCards.types'
import { GiftCardTableCell } from '../GiftCardTableCell/GiftCardTableCell'
import { GiftCardUsageTableCell } from '../GiftCardUsageTableCell/GiftCardUsageTableCell'

export const TABLE_HEADERS: TableHeaders<GiftCard> = [
  {
    id: 'code',
    label: 'Gift cards',
    render: (giftCard) => <GiftCardTableCell giftCard={giftCard} />,
    width: 6,
  },
  {
    id: 'status',
    label: 'Status',
    render: (giftCard) => <GiftCardStatusTag status={giftCard.status} />,
    width: 2,
  },
  {
    id: 'used',
    label: 'Current / Initial',
    render: (giftCard) => <GiftCardUsageTableCell giftCard={giftCard} />,
    width: 2,
  },
]
